const es = {
  "hotel.folio.guest": "Huéspedes",
  "hotel.folio.guest.name": "Nombre",
  "hotel.folio.guest.birthday": "Fecha Nac.",
  "hotel.folio.guest.id_number": "Número ID",
  "hotel.folio.guest.sex": "Sexo",
  "hotel.folio.guest.nationality": "Nacionalidad",
  "hotel.folio.guest.target_country": "País Destino",
  "hotel.folio.guest.email": "Correo Electrónico",
  "hotel.folio.guest.Nombres": "Nombre Completo",
  "hotel.folio.guest.typeDocument": "Tipo de Documento",
  "hotel.folio.guest.type_accomodation": "Tipo",
  "hotel.folio.guest.room": "Habitación",
  "hotel.folio.guest.phone": "Teléfono",
  "hotel.folio.guest.arrival_date": "Fecha de Entrada",
  "hotel.folio.guest.departure_date": "Fecha de Salida",
  "hotel.folio.guest.nights_quantity": "Cantidad de Noches",
  "hotel.folio.guest.unit_price": "Tarifa / Precio Unitario",
  "hotel.folio.guest.payment_status": "Estado del Pago",
  "hotel.folio.guest.channel": "Medio de Reserva",
  "hotel.folio.guest.reason": "Motivo de Viaje",
  "hotel.folio.guest.Tipo de Ocupante": "Tipo de Ocupante",
  "hotel.folio.guest.company": "Empresa",
  "hotel.folio.guest.Identificación Empresa": "Identificación Empresa",
  "hotel.folio.guest.vehicle_plate": "Placa del Vehículo",
  "hotel.folio.guest.adult": "Adulto",
  "hotel.folio.guest.child": "Niño",
  male: "Masculino",
  female: "Femenino",
  "hotel.folio.guest.main_guest": "Huesped Principal",
  "hotel.folio.guest.type_guest": "Tipo de Huesped",
  "hotel.folio.guest.type_document": "Tipo Doc.",
  "hotel.folio.guest.mobile": "Movil",
  "hotel.folio.guest.address": "Direccion",
  "hotel.folio.guest.origin_country": "País Origen",
  "hotel.folio.guest.notes": "Notas",
  "hotel.folio.guest.registro_civil": "Registro Civil de Nacimiento",
  "hotel.folio.guest.tarjeta_identidad": "Tarjeta de Identidad",
  "hotel.folio.guest.cedula_ciudadania": "Cedula de Ciudadania",
  "hotel.folio.guest.tarjeta_extranjeria": "Tarjeta de Extranjeria",
  "hotel.folio.guest.cedula_extranjeria": "Cedula de Extranjeria",
  "hotel.folio.guest.nit": "NIT",
  "hotel.folio.guest.add_guest": "Add",
  "hotel.folio.guest.cancel": "Cancelar",
  "hotel.folio.guest.pasaporte": "Pasaporte",
  "hotel.folio.guest.tipo_documento_extranjero": "Tipo de Documento Extranjero",
  "hotel.folio.guest.pep": "PEP",
  "hotel.folio.guest.nit_otro_pais": "NIT de otro país",
  "hotel.folio.guest.nuip": "NUIP",
  "hotel.folio.guest.country": "País",
  "hotel.folio.guest.subdivision": "Subdivision",
  "hotel.booking.link_web_checkin": "Enlace para el Check-in",
  "hotel.folio.guest.city_co": "Ciudad",
  "hotel.folio.guest.foreign_city": "Ciudad Extranjera",
  "hotel.folio.guest.welcome_tra":
    "Vamos a firmar la Tarjeta de Registro de Alojamiento (TRA)",
  "hotel.folio.guest.finish_tra": "¡Gracias por registrarte de forma digital!",
  "hotel.folio.guest.hello": "¡Hola",
  "hotel.folio.guest.finish": "¡Bienvenido al hotel! ",
  hotel_tra_register_card: "Tarjeta de Registro de Alojamiento (TRA)",
  "msg-introduction":
    "Firmaremos la Tarjeta de Registro de Alojamiento para validar tu hospedaje",
  "hotel.folio.guest.title-modal-select-lan": "Selecciona el idioma ",
  "hotel.folio.guest.btn_finish": "FINALIZAR",

  "hotel.folio.guest.content_guest": "Huespedes",
  "hotel.folio.guest.content_info_folio": "Información Huésped Principal",
  "hotel.folio.guest.content_contract": "Contrato de Alojamiento",
  "hotel.folio.guest.content_signature": "Firma Digital",
  "hotel.folio.guest.terms_and_conditions1":
    " He leído y acepto los términos y condiciones del contrato de hospedaje",
  "hotel.folio.guest.terms_and_conditions2":
    " y la política de tratamiento de datos personales del establecimiento",
  "hotel.folio.guest.guests_no_found": "No hay huéspedes invitados",
  "hotel.folio.guest.accept_contract":
    "Te falta aceptar el contrato de alojamiento",
  "hotel.folio.signature.updated": "Firma actualizada correctamente",
  "hotel.folio.guest.finish_description":
    "Con este pequeño gesto ayudaste a reducir el uso de papel y a cuidar el planeta. Cada acción cuenta. ",
  "hotel.folio.guest.landscape":
    "Disfruta de tu viaje, Conoce lo mejor del lugar y olvida tus peocupaciones. ",
};

export default es;
